<script>
  import { fade } from 'svelte/transition';
  import { LoginService } from '../services/login-service.js';
  import { form } from '../validate.js';
  import { showLoading } from '../components/Overlay.svelte';
  import { LoginError } from '../errors/app-errors.js';
  import { AppController } from '../AppController';
  import { onMount } from 'svelte';
  import { clearToasts } from '../components/Toast.svelte';

  export let params = {};

  AppController.setUser(null);

  const credentials = {
    email: '',
    password: ''
  }

  let loginErrorMessage = null;

  onMount(() => {
    clearToasts();
    if (location.hostname === "localhost") {
      //LoginService.signIn('steve@sierragolfsoftware.com', 'password');
    }
  });

  const { validate, ...signInForm } = form(() => ({
    email: { value: credentials.email, validators: ["required", "email"]},
    password: { value: credentials.password, validators: ["required"]},
  }));

  const signIn = async () => {
    try {
      showLoading(true);
      loginErrorMessage = null;
      await LoginService.signIn(credentials.email, credentials.password);
    } catch (err) {
      if (err instanceof LoginError) {
        loginErrorMessage = err.message;
      } else {
        // toast here

      }
      console.log(err);
    } finally {
      showLoading(false);
    }
  }

  // check to see if credentials were in query params
  if (params.email && params.password) {
    credentials.email = params.email;
    credentials.password = params.password;
    signIn();
  }
</script>

<div class="container-scroller" in:fade="{{duration: 1000}}">
  <div class="container-fluid page-body-wrapper full-page-wrapper">
    <div class="content-wrapper d-flex align-items-center auth px-0">
      <div class="row w-100 mx-0">
        <div class="col-lg-4 mx-auto">
          <div class="auth-form-light text-left py-5 px-4 px-sm-5">
            <div class="brand-logo">
              <img src="../../images/public_alert_logo2.jpg" alt="logo">
            </div>
            <h4>Sign in to Public Alert</h4>
            <h6 class="font-weight-light">Enter email and password</h6>
            {#if loginErrorMessage}
              <h6 class='text-danger'>{loginErrorMessage}</h6>
            {/if}
            <form class="pt-3">
              <div class="form-group">
                <input 
                  type="email" 
                  class="form-control form-control-lg"
                  class:border-danger={!$signInForm.email.valid && $signInForm.email.dirty}
                  id="exampleInputEmail1" 
                  placeholder="Email"
                  bind:value={credentials.email}
                  use:validate={credentials.email}
                  >
                  {#if ($signInForm.email.errors.includes('required') || 
                        $signInForm.email.errors.includes('email')) &&
                        $signInForm.email.dirty}
                    <p class='text-danger text-small'>Email is required</p>
                  {/if}
              </div>
              <div class="form-group">
                <input 
                  type="password" 
                  class="form-control form-control-lg" 
                  class:border-danger={!$signInForm.password.valid && $signInForm.password.dirty}
                  id="exampleInputPassword1" 
                  placeholder="Password"
                  use:validate={credentials.password}
                  bind:value={credentials.password}>
                  {#if $signInForm.password.errors.includes('required') && $signInForm.password.dirty}
                    <p class='text-danger text-small'>Password is required</p>
                  {/if}
              </div>
              <div class="mt-3">
                <button 
                  class="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn" 
                  on:click|preventDefault={signIn} 
                  class:disabled={!$signInForm.valid} 
                  disabled={!$signInForm.valid}>
                    SIGN IN
                  </button>
              </div>
              <div class="my-2 d-flex justify-content-between align-items-center">
                <!-- <div class="form-check">
                  <label class="form-check-label text-muted">
                    <input type="checkbox" class="form-check-input">
                    Keep me signed in
                  </label>
                </div> -->
                <a href="#/reset" class="auth-link text-black">Forgot password?</a>
              </div>
              <!-- <div class="text-center mt-4 font-weight-light">
                Don't have an account? <a href="register.html" class="text-primary">Create</a>
              </div> -->
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- content-wrapper ends -->
  </div>
  <!-- page-body-wrapper ends -->
</div>